module.exports = __webpack_public_path__ + "img/andrew-social-proof-cta.26f06ce6.png";